var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@folio/stripes/components';
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { hasError: false };
        _this.handleReset = function () {
            _this.setState({ hasError: false });
        };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function () {
        return { hasError: true };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        console.error('ErrorBoundary caught:', error, errorInfo);
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.hasError) {
            return (React.createElement("div", { style: { padding: '20px', textAlign: 'center' } },
                React.createElement("h2", null,
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.error.boundary.heading" })),
                React.createElement("p", null,
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.error.boundary.message" })),
                React.createElement(Button, { buttonStyle: "primary", onClick: this.handleReset },
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.error.boundary.retry" }))));
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(Component));
export { ErrorBoundary };
